import _ from 'underscore';

import {
    standardActionErrorMsg, standardActionSuccessMsg, StandardActionToastMessages
} from '~commonInfra/contentActions/ActionHelpers';
import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { openReactAlertDialog } from '~commonInfra/dialogs/ReactAlertDialog';
import { ChangeTagsActionHelperService } from '~content/services/ChangeTagsActionHelper';
import { Formatters, Messages } from '~src/codegen/Localize';
import { IDataSourceBase } from '~src/datasource/models/IDataSourceInfo';
import { DataSources } from '~src/datasource/resources/Datasources';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { DatasourceContentType } from '~src/spacesPlatform/models/ContentTypes';
import { L10n } from '~src/ts/L10n/L10n';
import { Set } from '~src/ts/models/Set';
import { IChangeContentTagsResult } from '~src/ts/ServerApi/types/IChangeContentTagsAction';
import { ContentUrlForItem } from '~src/ts/services/ContentUrl';

export namespace ChangeDatasourcesTagsAction {

  export const notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsDatasourcesSuccess),
    error: standardActionErrorMsg(Messages.changeTagsDatasourcesError),
  };

  export function execute(itemSet: Set<IDataSourceBase>): Promise<IChangeContentTagsResult> {
    return ChangeTagsActionHelperService.createExecuteFn<IDataSourceBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => DataSources.changeTags(ids, addTags, removeTags),
      getDescription: (datasources: Set<IDataSourceBase>) => getDescription(datasources),
      notificationFns: ChangeDatasourcesTagsAction.notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<IDataSourceBase>) => changeTagsErrorDetail(errorItem)
    })(itemSet);
  }

  function getDescription(datasources: Set<IDataSourceBase>) {
    return (datasources.size() === 1)
      ? Messages.changeTagsDatasourceDescription({ NAME: L10n.elideIfLong(datasources.first().name) })
      : Messages.changeTagsDatasourcesDescription({ COUNT_LOC: Formatters.formatCount(datasources.size()) });
  }

  export function showChangeTagsDialog(datasources: Set<IDataSourceBase>): Promise<IResult> {

    // Disallow changing tags if all selected datasources are embedded.
    if (datasources.all((ds: IDataSourceBase) => _.isObject(ds.workbook))) {
      return Promise.resolve(openReactAlertDialog({
        title: Messages.changeTagsDatasource_cannotTagAlertTitle(),
        message: Messages.changeTagsDatasource_cannotTagAlertMessage()
      }).result);
    }

    return execute(datasources);
  }

  export function changeTagsErrorDetail(errorItem: IErrorItem<IDataSourceBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, DatasourceContentType),
      errorMessage: ChangeTagsActionHelperService.errorMessageFor(errorItem)
    };
  }

}

export type ChangeDatasourcesTagsAction = typeof ChangeDatasourcesTagsAction;
